module.exports = __webpack_public_path__ + "img/instagram.3f96e108.svg";